import React, { lazy } from 'react';
import { Check } from 'lucide-react';
const BONUSES = [{
  title: 'Respiraciones que Calman',
  subtitle: 'en 60 Segundos',
  img: 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png',
  desc: 'Para bajar la ansiedad cuando aparece.'
}, {
  title: 'Rutinas Nocturnas',
  subtitle: 'para Dormir Mejor',
  img: 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png',
  desc: 'Para ayudar a tu cuerpo a soltar al final del día.'
}];
export function IncludesSection() {
  return <section className="py-20 bg-white px-4" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-156">
            📦 ¿Qué incluye tu acceso?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-157">
            Protocolo Calma-5™ – Paquete Completo
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-158">
          <div className="order-2 lg:order-1" data-id="element-159">
            <ul className="space-y-6" data-id="element-160">
              {['Sesión guiada de 5 minutos', 'Regulación en tiempo real', 'Respiración vagal', 'Reconexión corporal', 'Enfoque visual calmante'].map((item, i) => <li key={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#FAF5EF] transition-colors" data-id="element-161">
                  <div className="bg-[#C06B6B] p-1 rounded-full mt-1" data-id="element-162">
                    <Check className="h-4 w-4 text-white" data-id="element-163" />
                  </div>
                  <span className="text-lg text-gray-700 font-medium" data-id="element-164">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
          <div className="order-1 lg:order-2 flex justify-center" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png" alt="Calma tu Mente en 5 Minutos - Paquete Completo" className="w-3/4 max-w-md shadow-2xl rounded-lg rotate-3 hover:rotate-0 transition-transform duration-500" loading="lazy" data-id="element-166" />
          </div>
        </div>

        {/* Bonuses */}
        <div className="bg-[#FAF5EF] rounded-3xl p-8 md:p-12" data-id="element-167">
          <h3 className="text-2xl font-serif font-bold text-center text-[#C4973B] mb-4" data-id="element-168">
            🎁 Bonos GRATIS hoy:
          </h3>
          <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-169">
            💰 Valor total: $62 —{' '}
            <span className="font-bold text-[#C06B6B]" data-id="element-170">
              🎯 Hoy: solo $10.99 – pago único
            </span>
          </p>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-171">
            {BONUSES.map((bonus, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-172">
                <img src={bonus.img} alt={bonus.title} className="w-48 shadow-xl rounded-md mb-6 hover:scale-105 transition-transform" loading="lazy" data-id="element-173" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-174">
                  {bonus.title}
                </h4>
                <p className="text-[#C06B6B] font-medium mb-2" data-id="element-175">
                  {bonus.subtitle}
                </p>
                <p className="text-sm text-gray-600 max-w-xs" data-id="element-176">{bonus.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}